import React from 'react';
import Slider from 'react-slick';

class SlidersComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            nav1: null,
            nav2: null
        };
    }

    componentDidMount() {
        this.setState({
            nav1: this.slider1,
            nav2: this.slider2
        });
    }

    render() {
        let { main_sliders, sub_sliders} = this.props;
        // console.log(main_sliders);
        let slider_to_show = 1;
        // console.log(sub_sliders.length);
        if (sub_sliders && sub_sliders.length >= 6){
            slider_to_show = 5;
        } else {
            if (sub_sliders && sub_sliders.length > 1) {
                slider_to_show = sub_sliders.length - 1;
            }
        }

        return (

            <div className="block-index-slider">
                <div className="slider slider-for">
                    <Slider
                        asNavFor={this.state.nav2}
                        ref={slider => (this.slider1 = slider)}
                    >
                        {main_sliders}
                    </Slider>
                </div>
                <div className="container">
                    <div className="slider slider-nav custom-sub-slider container">
                        <Slider
                            asNavFor={this.state.nav1}
                            ref={slider => (this.slider2 = slider)}
                            slidesToShow={slider_to_show}
                            swipeToSlide={true}
                            focusOnSelect={true}
                            centerMode={true}
                            infinite={true}
                            autoplay={true}
                            speed={1000}
                        >
                            {sub_sliders}
                        </Slider>
                    </div>
                </div>
            </div>
        );
    }
}

export default SlidersComponent;



// WEBPACK FOOTER //
// ./src/components/MainPanel/SlidersComponent.js